import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tabs, Tab } from 'react-bootstrap';
import moment from 'moment';

import EventInfoForm from './forms/EventInfoForm.jsx';
import ContactInfoForm from './forms/ContactInfoForm.jsx';
import FinishingInfoForm from './forms/FinishingInfoForm.jsx';
import dataToForm from '../services/dataToForm';
import { appUrls } from '../config';

import { getFilteredEvents } from '../services/HandleFiltering';

import { selectEvent } from '../reducers/events';
import { switchView } from '../reducers/view';
import { updateForm } from '../reducers/forms';
import { setNotification } from '../reducers/notification';

import getEvents from '../services/eventFetchService';

import './css/form.css';

const mapStateToProps = state => ({
  events: getFilteredEvents(state),
  selectedEvent: state.events.selectedEvent,
  view: state.view.view,
  dateRange: { start: state.filter.STARTDATE, end: state.filter.ENDDATE }
});

const mapDispatchToProps = dispatch => ({
  changeView: viewName => changeView(dispatch, viewName),
  updateForm: formData => dispatch(updateForm(formData)),
  showError: () => dispatch(setNotification('Tallennus epäonnistui')),
  showNotification: message => dispatch(setNotification(message)),
  reloadEvents: () => getEvents(dispatch)
});

function changeView(dispatch, viewName) {
  dispatch(selectEvent(undefined));
  dispatch(switchView(viewName));
}

const PAGES = [
    { name: '1. Harjoituksen perustiedot', component: EventInfoForm },
    { name: '2. Yhteystiedot', component: ContactInfoForm },
    { name: '3. Lisätiedot ja viimeistely', component: FinishingInfoForm }
];

class EventEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      formData: {
        links: [{ url: '', text: '' }]
      },
      submitMessage: 'Harjoitus lisätty'
    };

    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateForm = this.updateForm.bind(this);
    this.displayError = this.displayError.bind(this);
    this.checkValidationErrors = this.checkValidationErrors.bind(this);
    this.getPageObjectComponent = this.getPageObjectComponent.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentWillMount() {
    const eventId = this.props.selectedEvent;
    for (const id in this.props.events) {
      if (this.props.events[id].EVENT_ID === eventId) {
        const preflightData = dataToForm(this.props.events[id]);
        this.setState({ formData: preflightData });
        this.setState({ submitMessage: 'Muokkaus onnistui' });
      }
    }
  }

  getPageObjectComponent(pageObject, index) {
    return (
      <Tab key={pageObject.name} eventKey={index} title={pageObject.name}>
        <Tab key={index} eventKey={index} title={pageObject.name}>
          <pageObject.component
            nextPage={this.nextPage}
            previousPage={this.previousPage}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
            handleCancel={this.handleCancel}
            displayError={this.displayError}
            updateForm={this.updateForm}
            checkValidationErrors={this.checkValidationErrors}
            state={this.state}
          />
        </Tab>
      </Tab>
    );
  }

  nextPage() {
    this.setState({ page: this.state.page + 1 });
  }

  previousPage() {
    this.setState({ page: this.state.page - 1 });
  }

  handleChange(type, value) {
    let newStateFormData = this.state.formData;
    newStateFormData[type] = value;
    newStateFormData = this.props.updateForm(newStateFormData).form;
    this.setState({ formData: newStateFormData });
  }

  handleCancel() {
    this.props.changeView('CALENDAR');
  }

  updateForm() {
    const updatedForm = this.props.updateForm(this.state.formData).form;
    this.setState({ formData: updatedForm });
  }

  displayError(type) {
    if (this.state.formData.errors === undefined || this.state.formData.errors[type] === undefined) {
      return { [type]: { status: null, error: '' } };
    }
    return { [type]: { status: 'error', error: this.state.formData.errors[type][0] } };
  }

  checkValidationErrors(state) {
    let hasErrors = false;
    const newState = state;
    this.updateForm();
    for (const type in state) {
      if (state[type].status !== undefined) {
        const inputValidationState = this.displayError(type);
        newState[type] = inputValidationState[type];
        if (inputValidationState[type].status !== null) {
          hasErrors = true;
        }
      }
    }
    if (!hasErrors) {
      (this.state.page !== 2) ? this.nextPage() : this.handleSubmit();
    }
    return newState;
  }

  handleSubmit() {
    const formToBeSubmitted = this.state.formData;
    delete formToBeSubmitted.errors;
    formToBeSubmitted.start_date = moment(this.state.formData.start_date, 'D.M.YYYY').format('YYYY-MM-DD');
    formToBeSubmitted.end_date = moment(this.state.formData.end_date, 'D.M.YYYY').format('YYYY-MM-DD');
    fetch(appUrls.save, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(formToBeSubmitted)
    })
    .then(response => response.json())
    .then((json) => {
      if (json.status === 'ok') {
        this.props.reloadEvents();
        this.props.changeView('CALENDAR');
        this.props.showNotification(this.state.submitMessage);
      } else {
        this.props.showError();
      }
    });
  }

  // empty function call for onSelect-function in <Tabs /> to keep React happy
  handleTabSelect = () => {

  }

  render() {
    return (
      <div className="ibox-content">
        <Tabs activeKey={this.state.page} onSelect={this.handleTabSelect} id="tab-bar">
          { PAGES.map(this.getPageObjectComponent) }
        </Tabs>
      </div>
    );
  }
}

EventEditor.propTypes = {
  updateForm: PropTypes.func.isRequired,
  changeView: PropTypes.func.isRequired,
  reloadEvents: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  events: PropTypes.array.isRequired,
  selectedEvent: PropTypes.string,
  showNotification: PropTypes.func.isRequired
};

EventEditor.defaultProps = {
  selectedEvent: ''
};

export default connect(mapStateToProps, mapDispatchToProps)(EventEditor);



// WEBPACK FOOTER //
// ./src/components/EventEditor.jsx